/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useFetch from 'use-http';
import { useEffectOnce } from 'react-use';
import { useHistory } from 'react-router-dom';
import { VisitServiceDetails } from './VisitServiceDetails';
import { VisitGeneralDetails } from './VisitGeneralDetails';
import { VisitAppointmentServiceRequestDetails } from './VisitAppointmentServiceRequestDetails';
import { VisitE025Details } from './VisitE025Details';
import { VisitPrescriptionsDetails } from './VisitPrescriptionsDetails';
import { VisitReferralsDetails } from './VisitReferralsDetails';
import { VisitInstrumentalResearchesDetails } from './VisitInstrumentalResearchesDetails';
import { VisitVaccinationDetails } from './VisitVaccinationDetails';
import { VisitLabaratoryResearchDetails } from './VisitLabaratoryResearchDetails';
import Page from '@/components/shared/Page';
import Loader from '@/components/shared/Loader';
import { useUserState } from '@/components/context/UserContext';
import InstrumentalResearchDocumentsCard from '../../UserAccountInstrumentalResearchDetailsPage/Components/InstrumentalResearchDocumentsCard';

const VisitDetails = (props) => {
  const history = useHistory();
  const vaccinationRef = useRef(null);
  const referralsRef = useRef(null);
  const instrumentalResearchesRef = useRef(null);
  const laboratoryResearchesRef = useRef(null);
  const prescriptionsRef = useRef(null);
  const e025Ref = useRef(null);
  const [VisitDetails, setVisitDetails] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const executeScroll = (ref) => scrollToRef(ref);
  const scrollToRef = (ref) => {
    window.scrollTo(0, ref.current.offsetTop + 145);
  };

  const visitDetails = history.location.state?.visit;
  const otherVisit = history.location.state?.fromOtherVisits;
  const fromE025 = history.location.state?.fromE025;
  const userState = useUserState();
  const { get: getVisitDetails } = useFetch('/UserAccount/VisitDetails');

  const { get: getFile } = useFetch('/UserAccount/DownloadAmisFile');
  const handleFileDownload = async (category, filename, fileType, fileGuid) => {
    await getFile(
      `?fileType=${fileType}&fileGuid=${fileGuid}&category=${category}`,
    ).then((res) => {
      const base64Data = res;
      const blob = base64toBlob(base64Data, 'application/pdf');
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = `${filename}.pdf`;
      document.body.appendChild(downloadLink);
      setTimeout(() => {
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }, 120);
    });
  };

  function base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  const getUserVisitDetailsInformation = async (visitId) => {
    setLoading(true);
    let queryString = userState.espbiEsi
      ? `?visitId=${visitId}&espbiEsi=${userState.espbiEsi}`
      : `?visitId=${visitId}`;

    getVisitDetails(queryString).then((res) => {
      setVisitDetails(res);
      setLoading(false);
    });
  };

  useEffectOnce(() => {
    getUserVisitDetailsInformation(visitDetails.visitId);
  });

  useEffect(() => {
    scrollToTitle(props);
  }, [props]);

  function scrollToTitle(props) {
    switch (props.scrollTo) {
      case 'prescriptionsRef':
        executeScroll(prescriptionsRef);
        break;
      case 'vaccinationRef':
        executeScroll(vaccinationRef);
        break;
      case 'instrumentalResearchesRef':
        executeScroll(instrumentalResearchesRef);
        break;
      case 'e025Ref':
        executeScroll(e025Ref);
        break;
      case 'referralsRef':
        executeScroll(referralsRef);
        break;
    }
  }

  if (loading) {
    return (
      <Page>
        <Loader />
      </Page>
    );
  }
  return (
    <>
      {Array.isArray(visitDetails.services) &&
      visitDetails.services.length > 0 ? (
        <VisitServiceDetails visitDetails={visitDetails} />
      ) : (
        <VisitGeneralDetails visitDetails={visitDetails} />
      )}
      {VisitDetails && VisitDetails.appointmentServiceRequest && (
        <div className="mb-4">
          <VisitAppointmentServiceRequestDetails
            appointmentServiceRequest={VisitDetails.appointmentServiceRequest}
            handleFileDownload={handleFileDownload}
          />
        </div>
      )}
      {VisitDetails &&
        Array.isArray(VisitDetails.e025) &&
        VisitDetails.e025.length > 0 && (
          <VisitE025Details
            e025List={VisitDetails.e025}
            e025Ref={e025Ref}
            handleFileDownload={handleFileDownload}
          />
        )}
      {VisitDetails &&
        Array.isArray(VisitDetails.medicationStatements) &&
        VisitDetails.medicationStatements.length > 0 && (
          <VisitPrescriptionsDetails
            prescriptions={VisitDetails.medicationStatements}
            prescriptionsRef={prescriptionsRef}
            handleFileDownload={handleFileDownload}
          />
        )}
      {VisitDetails &&
        Array.isArray(VisitDetails.serviceRequests) &&
        VisitDetails.serviceRequests.length > 0 && (
          <div ref={referralsRef}>
            {VisitDetails.serviceRequests.map((referral, index) => {
              return (
                <VisitReferralsDetails
                  referrals={VisitDetails.serviceRequests}
                  referralsRef={referralsRef}
                  handleFileDownload={handleFileDownload}
                />
              );
            })}
          </div>
        )}
      {VisitDetails &&
        Array.isArray(VisitDetails.instrumentalDiagnosticReports) &&
        VisitDetails.instrumentalDiagnosticReports.length > 0 && (
          <div ref={instrumentalResearchesRef} className="mt-5 mb-5 space-y-5">
            {VisitDetails.instrumentalDiagnosticReports.map(
              (research, index) => (
                <InstrumentalResearchDocumentsCard
                  key={research?.id ?? research?.Id ?? index}
                  research={research}
                />
              ),
            )}
          </div>
        )}
      {VisitDetails &&
        Array.isArray(VisitDetails.immunizations) &&
        VisitDetails.immunizations.length > 0 && (
          <VisitVaccinationDetails
            vaccinations={VisitDetails.immunizations}
            vaccinationRef={vaccinationRef}
            handleFileDownload={handleFileDownload}
          />
        )}
      {VisitDetails &&
        Array.isArray(VisitDetails.laboratoryFiles) &&
        VisitDetails.laboratoryFiles.length > 0 && (
          <VisitLabaratoryResearchDetails
            laboratoryFiles={VisitDetails.laboratoryFiles}
            laboratoryResearchesRef={laboratoryResearchesRef}
            handleFileDownload={handleFileDownload}
          />
        )}
    </>
  );
};
export default VisitDetails;
